import { DateTime } from "luxon";
import { z } from "zod/v4-mini";

import { IBFLogRecord } from "@/lib/drivers/insulet/IBFRecords/IBF_LOG_RECORD";
import { Schema, cz } from "@/utils/zodUtils";

export type Version = {
  major: number;
  minor: number;
  patch: number;
};

export const omnipodVersionToString = (version: Version) => `${version.major}.${version.minor}.${version.patch}`;

export type OmnipodVersions = {
  ibf: Version;
  engine: Version;
  pdm: Version;
};

export type OmnipodProfileSegment = {
  start: number;
  end: number;
  basalInsulin: number;
  carbsRatio: number;
  insulinSensitivity: number;
  targetBG: number;
  thresholdBG: number;
};

export type OmnipodProfile = {
  index: number;
  name: string;
  isActive: boolean;
  segments: OmnipodProfileSegment[];
};

export type OmnipodPumpSettings = {
  maxBolus: number;
  maxBasal: number;
  bolusIncrement: number;
  hypoglycemiaThreshold: number;
  hyperglycemiaThreshold: number;
  activeInsulinTime: number;
  units: "mg/dL" | "mmol/L";
};

export type OmnipodConfigInfo = {
  versions: OmnipodVersions;
  vendorId: string;
  productId: string;
  model: "Dash" | "Eros";
  manufacturingNumber: string;
  profiles: OmnipodProfile[];
  serialNumber: string;
  pumpSettings: OmnipodPumpSettings;
};

export type OmnipodData = {
  info: OmnipodConfigInfo;
  uploadDate: DateTime;
  logs: IBFLogRecord[];
  endDate: DateTime | undefined;
};

export type OmnipodLastUploadInfo = {
  last_fetched_date?: string;
};

export const omnipodUploadInfoSchema: Schema<OmnipodLastUploadInfo> = z.object({
  last_fetched_date: cz.optional(cz.datetime()),
});
